export default __webpack_public_path__ + "img/fcfc95233ce0931b8c76c20d8fefbb47.svg";